import type { ThemeOptions } from '@material-ui/core/styles';

// Nerdwallet theme
export default {
  palette: {
    primary: {
      main: '#007F53',
      light: '#00804e1a',
      dark: '#005C3C',
    },
    secondary: {
      main: '#0C9968',
    },
  },
} as ThemeOptions;
